import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ClashListDto } from '@models/clash/clashes/clash-list-dto';
import { RecordClashesForm } from '@models/clash/clashes/record-clashes-form';
import { RegistrationKeyCompleteDto } from '@models/clash/clashes/registration-key-complete-dto';
import { ICompleteStepParameterizationDto } from '@models/competition/step-paramaterization/dtos/complete-simple-step-parameterization-dto';
import { ClashService } from '@shared/services/clash.service';
import { ClashRegistrationService } from '@shared/services/competition/clash-registration/clash-registration.service';
import { StepParameterizationService } from '@shared/services/competition/step-parametrization.service';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';
import { IPage } from './../../../../models/pagination/page';

@Component({
  selector: 'sigecom-modal-add-participants',
  templateUrl: './modal-add-participants.component.html',
})
export class ModalAddParticipantsComponent
  extends BaseComponent
  implements OnInit
{
  abaSelecionada = 'Adicionar participantes';

  #clashService = inject(ClashService);
  #clashRegistration = inject(ClashRegistrationService);
  #stepParameterizationService = inject(StepParameterizationService);
  //  route = inject(ActivatedRoute)

  recordClashesForm!: RecordClashesForm;

  @Output() viewParticipants = new EventEmitter<boolean>();
  @Output() participantAdded = new EventEmitter<boolean>();

  participants?: IPage<RegistrationKeyCompleteDto>;

  participantsAdded: RegistrationKeyCompleteDto[] = [];
  @Input() selectedParticipants: RegistrationKeyCompleteDto[] = [];
  totalParticipants: number = 0;

  clashListDto!: IPage<ClashListDto>;
  clashDto!: ClashListDto;

  @Input() cheNrId!: number;
  @Input() petNrId!: number;
  incTxResumo!: string;
  @Input() embNrId?: number;
  embNrIdSec?: number;

  parameterizationDto!: ICompleteStepParameterizationDto;

  // o patNrId deve ser number, esta assim apenas para teste
  @Output() parNrId = new EventEmitter<string>();
  @Output() selectedParticipant =
    new EventEmitter<RegistrationKeyCompleteDto>();

  ngOnInit() {
    this.#searchForKeySubscribers();
    this.#findParameterization();
  }

  changeTab(tab: string) {
    console.log(tab);
  }

  #findParameterization() {
    this.#stepParameterizationService
      .getStepParametrizationById$(this.petNrId)
      .subscribe({
        next: (res) => {
          this.parameterizationDto = res;
        },
      });
  }

  #searchForKeySubscribers(incTxResumo?: string, page?: number) {
    this.#clashService
      .searchForKeySubscribers(this.cheNrId, incTxResumo, {
        size: 10,
        page: page!,
      })
      .subscribe({
        next: (res) => {
          this.participants = res;
          this.participantsAdded = this.selectedParticipants;

          if (
            this.participants &&
            this.participants.content &&
            this.participantsAdded
          ) {
            // Garante que a lista de disponíveis não contenha os participantes já adicionados
            this.participants.content = this.participants.content.filter(
              (p) =>
                !this.participantsAdded.some((sp) => sp.ichNrId === p.ichNrId),
            );
          }
        },
      });
  }

  filterIncTxNome(incTxResumo: string) {
    this.incTxResumo = incTxResumo;
    this.#searchForKeySubscribers(incTxResumo);
  }

  closeModalViewParticipants() {
    this.viewParticipants.emit(false);
  }

  // o patNrId deve ser number, esta assim apenas para teste
  openModalViewParticipants(patNrId: string) {
    this.parNrId.emit(patNrId);
    this.viewParticipants.emit(true);
  }

  onPageChange(page: number) {
    this.#searchForKeySubscribers(this.incTxResumo, page);
  }

  #listClashesCheNrId(cheNrId: number) {
    console.warn('Tryed to list clashes', cheNrId);
    return;
    this.#clashRegistration.getRegistraionClash().subscribe({
      next: (res) => {
        this.clashListDto = res;

        res.content?.forEach((clash) => {
          clash.embListInscricaoDto.forEach((inscricao) => {
            const participante = {
              inscricaoEtapaDto: {
                ineObjInscricao: {
                  incTxResumo:
                    inscricao.embateDto?.inscricaoEtapaDto.ineObjInscricao
                      .incTxResumo,
                },
              },
            } as RegistrationKeyCompleteDto;

            this.participants!.content = this.participants!.content!.filter(
              (p) =>
                p.inscricaoEtapaDto.ineNrId !==
                inscricao.embateDto?.inscricaoEtapaDto.ineNrId,
            );
            this.participantsAdded.push(participante);
            this.totalParticipants = this.participantsAdded.length;
          });
        });
      },
    });
  }

  addParticipant(participants: RegistrationKeyCompleteDto) {
    if (!this.participants || !this.participants.content) return;
    this.participantsAdded.push(participants);
    this.totalParticipants = this.participantsAdded.length;

    // Remove da lista original
    this.participants.content = this.participants.content.filter(
      (p) => p !== participants,
    );

    this.selectedParticipant.emit(participants);
  }
}
